<template>
  <div id="wrap">
    <Header/>
    <Scroll/>
    <div class="hp_productWrap">
      <div class="hp_productMain_tit"><!-- travel_title_area -->
        <h1>커뮤니티</h1>
      </div>

      <div class="hp_productMain_contentWrap"> <!-- travel_content -->
        <div class="hp_productMain_contentSidebar"><!-- travel_sidebar -->
          <div class="hp_productMain_contentMenuBox">
            <ul class="hp_productMain_contentMenu"><!-- travel_menu -->
              <li :class="{ 'hp_productMain_contentMenu_active': 1 === statusData.communityID }">
                <a href="/Community?communityID=1">공지사항</a>
              </li>
              <li :class="{ 'hp_productMain_contentMenu_active': 2 === statusData.communityID }">
                <a href="/Community?communityID=2">여행후기</a>
              </li>
              <li :class="{ 'hp_productMain_contentMenu_active': 3 === statusData.communityID }">
                <a href="/Community?communityID=3">온라인문의</a>
              </li>
              <li :class="{ 'hp_productMain_contentMenu_active': 4 === statusData.communityID }">
                <a href="/Community?communityID=4">자주 묻는 질문</a>
              </li>
              <li :class="{ 'hp_productMain_contentMenu_active': 5 === statusData.communityID }">
                <a href="/Community?communityID=5">단체여행문의</a>
              </li>
            </ul>
          </div>

          <!-- Hot Keywords -->
          <div class="hp_productMain_contentKeywordBox hp_MobNonePcBlock">
            <p class="hp_productMain_contentKeyword_tit">HOT키워드<span>여행</span></p>
            <div class="hp_productMain_contentKeyword_tagBox">
              <p v-for="item in statusData.hotKeywordData" :key="item.hot_keyword_ID">
                <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(item.hot_keyword_name)}`">
                  #{{ item.hot_keyword_name }}
                </a>
              </p>
            </div>
          </div>
        </div>

        <!-- 글쓰기 -->
        <div class="hp_mypageListWrap">
          <div class="hp_mypageListWrapTit">
            {{statusData.communityName}}
          </div>
          <div class="hp_reservationBox">
            <table class="hp_tableForm hp_commuWriteTable" cellpadding="0" cellspacing="0" :summary="statusData.communityName">
              <caption>{{statusData.communityName}}</caption>
              <colgroup>
                <col width="20%">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th>
                    <label for = 'writer'>작성자</label>
                  </th>
                  <td>
                    <input
                      type = "text"
                      class="hp_tableInputBox"
                      id = 'writer'
                      v-model="formData.writer"
                      maxlength="10"
                    >
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'email'>이메일</label>
                  </th>
                  <td>
                    <input
                      type = "text"
                      class="hp_tableInputBox"
                      id = 'email'
                      v-model="formData.email"
                      maxlength="50"
                    >
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'title'>제목</label>
                  </th>
                  <td>
                    <input
                      type = "text"
                      class="hp_tableInputBox"
                      id = 'title'
                      v-model="formData.title"
                      maxlength="50"
                    >
                    <!-- 온라인 문의시에만 표시 : 비밀글 체크박스 -->
                    <div class="hp_tableInputCheckSecret" v-if="statusData.communityID === 3">
                      <input
                        class="hp_tableInputCheck"
                        type = "checkbox"
                        id = 'online_inquiry_security_status'
                        v-model="formData.onlineInquirySecurityStatus"
                      >
                      <label class="hp_tableInputCheck_label" for = 'online_inquiry_security_status'>비밀글</label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <!-- <th>
                    <label for = 'editor'>내용</label>
                  </th> -->
                  <td colspan="2">
                    <custom-textarea
                      v-model="formData.editor"
                      :id="'editor'"
                    />
                  </td>
                </tr>
                <!-- 여행 후기 작성시에만 표시 : 메인 이미지 표시 -->
                <tr v-if="statusData.communityID === 2">
                  <th>
                    <label for = 'travel_review_main_image'>썸네일</label>
                  </th>
                  <td>
                    <div class="hp_commuPostImgWrap">
                      <input
                        type='file'
                        id = 'travel_review_main_image'
                        accept='image/gif, image/jpeg, image/png'
                        @change="changeImage"
                      />
                      <p class="hp_commuPostImgBox">
                        <img
                          :src="formData.travelReviewMainImageUrl === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.travelReviewMainImageUrl"
                          alt="메인 이미지"
                        />
                      </p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'security_code'>보안코드</label>
                  </th>
                  <td>
                    <div class="securityTxt">{{statusData.securityCode}}</div>
                    <input
                      type = "text"
                      class="hp_tableInputBox"
                      id = 'security_code'
                      v-model="formData.securityCode"
                      maxlength="4"
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="hp_commuDetail_privacyBox"> <!-- 댓글 작성 약관 동의 -->
            <div class="hp_commuDetail_pbAll">
              <input  type="checkbox" id="agreeAll" v-model="formData.agreeAll" @change="toggleAllAgreements" />
              <label for="agreeAll">이용약관 및 개인정보방침에 모두 동의합니다.</label>
            </div>
            <div class="hp_commuDetail_pbEarch">
              <div>
                <input type="checkbox" id="agree1" v-model="formData.agree1" @change="checkIndividualAgreements" />
                <label for="agree1"><span>[필수]</span> 수집하는 개인정보의 항목에 동의</label>
              </div>
              <button type="button" @click="togglePopup(1)">약관보기</button>
            </div>
            <div class="hp_commuDetail_pbEarch">
              <div>
                <input type="checkbox" id="agree2" v-model="formData.agree2" @change="checkIndividualAgreements" />
                <label for="agree2"><span>[필수]</span> 개인정보의 수집 이용목적에 동의</label>
              </div>
              <button type="button" @click="togglePopup(2)">약관보기</button>
            </div>
            <div class="hp_commuDetail_pbEarch">
              <div>
                <input type="checkbox" id="agree3" v-model="formData.agree3" @change="checkIndividualAgreements" />
                <label for="agree3"><span>[필수]</span> 개인정보의 보유 및 이용기간에 동의</label>
              </div>
              <button type="button" @click="togglePopup(3)">약관보기</button>
            </div>
          </div>
          <div class="hp_myFix_btnReservMob">
            <div class="hp_commuDetail_BtnBox">
              <a @click="write()">{{ this.statusData.editStatus === 0 ? '확인' : '수정' }}</a>
              <a :href="'/Community?communityID='+statusData.communityID" class="hp_commuDetail_BtnBox_list">목록</a>
            </div>
          </div>
          <div class="hp_reservation_btnReservPc">
            <div class="hp_commuDetail_BtnBox">
              <a @click="write()">{{this.statusData.editStatus === 0 ? '확인' : '수정' }}</a>
              <a :href="'/Community?communityID='+statusData.communityID" class="hp_commuDetail_BtnBox_list">목록</a>
            </div>
          </div>
        </div>
        <!-- 글쓰기 -->
      </div>
    </div>
    <PopupComponent
      :isVisible="statusData.isPopupVisible"
      :toggleStatus="statusData.toggleStatus"
      @update:isVisible="statusData.isPopupVisible = $event"
    />
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import CustomTextarea from '../../ETC/CustomTextarea.vue'
import { editorsReady } from '../../ETC/editor/form'
import PopupComponent from '../Section/PopupComponent.vue'
import {
  get_session_customer,
  get_hot_keyword_top10,
  insert_community,
  update_community,
  get_online_inquiry_one,
  get_travel_review_one
} from '../../ETC/Axios.vue'

export default {
  name: 'My',
  components: {
    Header,
    Footer,
    Scroll,
    CustomTextarea,
    PopupComponent
  },
  setup () {
    return {
      sessionData: ref({
        customer: ''
      }),
      statusData: ref({
        communityID: 2,
        communityName: '여행후기',
        hotKeywordData: [],
        securityCode: '',
        toggleStatus: 1,
        isPopupVisible: false,
        editStatus: 0
      }),
      formData: ref({
        pk_id: 0,
        writer: '',
        email: '',
        title: '',
        onlineInquirySecurityStatus: false,
        editor: '',
        travelReviewMainImage: '',
        travelReviewMainImageUrl: '',
        securityCode: '',
        agreeAll: false,
        agree1: false,
        agree2: false,
        agree3: false
      })
    }
  },
  methods: {
    goToHome () {
      window.location.href = `/`
    },
    togglePopup (toggleStatus) {
      this.statusData.toggleStatus = toggleStatus
      this.statusData.isPopupVisible = true
    },
    toggleAllAgreements () {
      this.formData.agree1 = this.formData.agreeAll
      this.formData.agree2 = this.formData.agreeAll
      this.formData.agree3 = this.formData.agreeAll
    },
    checkIndividualAgreements () {
      if (this.formData.agree1 && this.formData.agree2 && this.formData.agree3) {
        this.formData.agreeAll = true
      } else {
        this.formData.agreeAll = false
      }
    },
    changeImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.travelReviewMainImage = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.travelReviewMainImageUrl = reader.result
        }
      }
    },
    generateSecurityCode () {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let result = ''
      for (let i = 0; i < 4; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.statusData.securityCode = result
    },
    write () {
      // 업로드가 끝난 HTML을 기존 API로 전송한다.
      if (!editorsReady(this)) return
      const nameRegex = /^[가-힣a-zA-Z]{2,}$/
      if (!nameRegex.test(this.formData.writer)) {
        alert('작성자는 최소 2자리의 한글 또는 영문만 입력할 수 있습니다.')
        return
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (this.formData.email && !emailRegex.test(this.formData.email)) {
        alert('이메일 형식이 올바르지 않습니다.')
        return
      }
      if (!this.formData.writer) {
        alert('작성자는 필수 입력 항목입니다.')
        return
      }
      if (!this.formData.title) {
        alert('제목은 필수 입력 항목입니다.')
        return
      }
      if (!this.formData.editor) {
        alert('내용은 필수 입력 항목입니다.')
        return
      }
      if (this.statusData.communityID === 2 && !this.formData.travelReviewMainImageUrl) {
        alert('메인이미지는 필수 입력 항목입니다.')
        return
      }
      if (this.formData.securityCode !== this.statusData.securityCode) {
        alert('보안 코드가 일치하지 않습니다.')
        return
      }
      if (!this.formData.agree1 || !this.formData.agree2 || !this.formData.agree3) {
        alert('모든 필수 동의 항목에 체크해주세요.')
        return
      }
      if (this.statusData.editStatus === 0) {
        insert_community(
          this.sessionData.customer.customer_ID,
          this.statusData.communityID,
          this.formData.writer,
          this.formData.email,
          this.formData.title,
          this.formData.onlineInquirySecurityStatus,
          this.formData.editor,
          this.formData.travelReviewMainImage
        ).then(result => {
          alert('등록이 완료되었습니다.')
          window.location.href = `/Community?communityID=${this.statusData.communityID}`
        })
      } else {
        update_community(
          this.formData.pk_id,
          this.statusData.communityID,
          this.formData.writer,
          this.formData.email,
          this.formData.title,
          this.formData.onlineInquirySecurityStatus,
          this.formData.editor,
          this.formData.travelReviewMainImage
        ).then(result => {
          alert('수정이 완료되었습니다.')
          window.location.href = `/Community?communityID=${this.statusData.communityID}`
        })
      }
    }
  },
  mounted () {
    if (this.$route.query.communityID !== undefined) {
      this.statusData.communityID = +this.$route.query.communityID
      if (+this.$route.query.communityID === 2) {
        this.statusData.communityName = '여행후기'
      } else if (+this.$route.query.communityID === 3) {
        this.statusData.communityName = '온라인문의'
      }
    }
    get_hot_keyword_top10().then(result => {
      this.statusData.hotKeywordData = result
    })
    get_session_customer().then(result_session => {
      this.sessionData.customer = result_session
      this.formData.writer = result_session.customer_name
      this.formData.email = result_session.customer_email
      if (result_session === '') {
        window.location.href = '/Login'
      } else {
        if (this.$route.query.travel_review_ID !== undefined) {
          get_travel_review_one(this.$route.query.travel_review_ID).then(result => {
            if (result.travel_review[0].customer_ID_use_travel_review !== result_session.customer_ID && this.sessionData.customer.customer_super_status !== 1) {
              alert('본인이 작성한 글만 확인할 수 있습니다.')
              window.location.href = '/Community?communityID=2'
            } else {
              this.formData.pk_id = result.travel_review[0].travel_review_ID
              this.formData.writer = result.travel_review[0].travel_review_write
              this.formData.email = result.travel_review[0].travel_review_email
              this.formData.title = result.travel_review[0].travel_review_title
              this.formData.editor = result.travel_review[0].travel_review_editor
              this.formData.travelReviewMainImageUrl = result.travel_review[0].travel_review_main_image
              this.statusData.editStatus = 1
            }
          })
        } else if (this.$route.query.online_inquiry_ID !== undefined) {
          get_online_inquiry_one(this.$route.query.online_inquiry_ID).then(result => {
            if (result.online_inquiry[0].customer_ID_use_online_inquiry !== result_session.customer_ID && this.sessionData.customer.customer_super_status !== 1) {
              alert('본인이 작성한 글만 확인할 수 있습니다.')
              window.location.href = '/Community?communityID=3'
            } else {
              this.formData.pk_id = result.online_inquiry[0].online_inquiry_ID
              this.formData.writer = result.online_inquiry[0].online_inquiry_write
              this.formData.email = result.online_inquiry[0].online_inquiry_email
              this.formData.title = result.online_inquiry[0].online_inquiry_title
              this.formData.onlineInquirySecurityStatus = result.online_inquiry[0].online_inquiry_security_status
              this.formData.editor = result.online_inquiry[0].online_inquiry_editor
              this.statusData.editStatus = 1
            }
          })
        }
      }
    })
    this.generateSecurityCode()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Community/CommunityWrite.vue